
import React from "react";
import { Clock } from "lucide-react";
import { Site } from "@/services/types";

interface SiteCardHoursProps {
  site: Site;
  formatOpeningHours: (site: Site) => string;
}

const SiteCardHours = ({ site, formatOpeningHours }: SiteCardHoursProps) => {
  return (
    <div className="flex items-start">
      <Clock className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
      <p className="text-gray-700 whitespace-pre-line">{formatOpeningHours(site)}</p>
    </div>
  );
};

export default SiteCardHours;
